

import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { TestedIndividualService } from 'src/app/services/tested-individual.service';
import { ActivatedRoute } from '@angular/router';
import { EncryptDecryptService } from 'src/app/services/encrypt-decrypt.service';
import { Observable } from 'rxjs';
import { DeleteConfirmModalComponent } from 'src/app/commons/delete-confirm-modal/delete-confirm-modal.component';

@Component({
  selector: 'app-edit-candidate-modal',
  templateUrl: './edit-candidate-modal.component.html',
  styleUrls: ['./edit-candidate-modal.component.scss']
})
export class EditCandidateModalComponent implements OnInit {
  loading: boolean;
  passwordMismatch: boolean;
  error: string;
  errorFromserver: string;
  jobId: any;
  show: boolean;
  pwd: boolean;

  systemDate = new Date();

  show1: boolean;
  pwd1: boolean;

  constructor(public dialog: MatDialog, public dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data: any,
    public _testedIndividualService: TestedIndividualService, public activatedRoute: ActivatedRoute, public _EncryptDecryptService: EncryptDecryptService) { }

  ngOnInit() {
    console.log("data in edit candidate model", this.data);

    this.data.password = this._EncryptDecryptService.decrypt(this.data.password)
    this.data.confirmPassword = this.data.password;

    console.log('Modal Data In Add Candidate:', this.data);

    $("#password").click(function () {
      $("#password").toggleClass("fa-eye fa-eye-slash");
    });

    $("#cpassword").click(function () {
      $("#cpassword").toggleClass("fa-eye fa-eye-slash");
    });
  }

  validate(data) {
    console.log("Validating ", data);
    if (!data.name) return { valid: false, field: "Name" };
    if (!data.email) return { valid: false, field: "Email" };
    if (data.password !== data.confirmPassword) {
      this.passwordMismatch = true;
      return false
      // return { valid: false, field: "Password Missmatch" };
    }
    this.passwordMismatch = false;
    return true
  }

  doSubmit() {
    this.error = ""
    this.errorFromserver = ""
    console.log("Submit ", this.data);
    console.log("Validating = ", this.validate(this.data));
    if (!this.validate(this.data)) {
      console.log("RETURNING");
      return;
    }

    let user = {
      name: this.data.name,
      email: this.data.email,
      password: this._EncryptDecryptService.encrypt(this.data.password),
      _id: this.data.userId
    }

    console.log('Candidate Edit Data', user);

    // Do Submit
    this.loading = true;

    this._testedIndividualService.editCandidate(user).subscribe(data => {
      this.data = data;
      this.loading = false;
      this.closoeDialog({
        action: 'edit',
        result: 'success',
        data: this.data
      });
      // this.dialogRef.close(data);


    }, err => {
      this.loading = false;
      // this.errorFromserver = err.msg
    });
  }

  delete() {
    this.openDialog(DeleteConfirmModalComponent, "Candidate").subscribe(confirm => {
      if (confirm == '') return
      else if (confirm == 'yes') {
        this.loading = true;
        this._testedIndividualService.deleteTestedIndividual(this.data.userId).subscribe(res => {
          this.loading = false;
          this.closoeDialog({
            action: 'delete',
            result: 'success',
            data: this.data
          });
        }, err => {
          this.loading = false;
          this.closoeDialog({
            action: 'delete',
            result: 'err',
            data: err
          });
        });
      }
    })
  }

  password() {
    this.show = !this.show;
    this.pwd = !this.pwd;
  }

  cpassword() {
    this.show1 = !this.show1;
    this.pwd1 = !this.pwd1
  }

  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, { data });
    return dialogRef.afterClosed();
  }
  closoeDialog(result) {
    this.dialogRef.close(result);
  }
}

